var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 29,
    viewBox: "0 0 241 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 28.7614C28.4998 28.7614 30.3931 20.6064 30.3931 14.8329V0.644531H20.9628V14.6115C20.9628 18.1865 19.4694 20.8352 15.4854 20.8352H15.2194C10.3051 20.8352 9.87264 17.1486 9.77308 16.0759H0.509277V16.2992C0.509277 21.0586 2.53471 28.7761 14.2548 28.7761H16.2803V28.7614Z",
    fill: "url(#paint0_linear_3548_73169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6192 28.8758C98.4958 28.8758 100.82 21.0539 100.82 17.4441V16.8455H91.0566C90.9244 17.4789 90.1916 21.3907 82.9206 21.3907C76.2796 21.3907 74.6197 17.4807 74.6197 14.5006V14.054C74.6197 10.964 76.0805 7.57207 82.888 7.57207C90.0594 7.57207 90.8233 11.072 91.024 11.8189H100.817V11.3356C100.817 7.76062 98.6247 0.125488 83.6159 0.125488H82.3217C66.9146 0.125488 64.8582 8.57886 64.8582 13.8673V14.9491C64.8582 20.2009 67.1431 28.8776 82.3217 28.8776H83.6159L83.6192 28.8758Z",
    fill: "url(#paint1_linear_3548_73169)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.508 28.3514V15.9532L124.559 28.3532H136.847L122.003 13.2349L136.382 0.646362H124.654L112.501 11.5966V0.644531H103.077V28.3514H112.508Z",
    fill: "url(#paint2_linear_3548_73169)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.399 19.6738C167.432 19.6738 170.12 15.427 170.12 10.4004V9.80547C170.12 4.70379 167.529 0.652832 158.399 0.652832H137.811V28.3505H147.242V19.6738H158.399ZM147.242 7.57039H157.266C159.489 7.57039 160.387 8.5003 160.387 10.1038V10.2173C160.387 11.744 159.422 12.7508 157.266 12.7508H147.237V7.57039H147.242Z",
    fill: "url(#paint3_linear_3548_73169)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.45 0.12207C173.446 0.12207 171.419 8.6505 171.419 13.8638V14.9805C171.419 20.1572 173.444 28.8723 189.45 28.8723H190.945C206.917 28.8723 208.941 20.1572 208.941 14.9805V13.8638C208.941 8.6505 206.881 0.12207 190.945 0.12207L189.45 0.12207ZM199.179 14.6473C199.179 17.6256 197.485 21.3873 190.181 21.3873C182.878 21.3873 181.184 17.4773 181.184 14.5723V14.1256C181.184 11.1839 182.744 7.57232 190.181 7.57232C197.488 7.57232 199.179 11.1839 199.179 14.1256V14.6473Z",
    fill: "url(#paint4_linear_3548_73169)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.324 28.3514H229.755V8.20461H240.416V0.644531H209.667V8.20461H220.324V28.3514Z",
    fill: "url(#paint5_linear_3548_73169)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3471 10.0726L50.8116 15.7253C51.01 16.196 51.3249 16.5927 51.7187 16.8683C52.1125 17.1438 52.5687 17.2865 53.0329 17.2794H57.575C57.8156 17.2794 58.0511 17.3582 58.2524 17.5061C58.4536 17.654 58.612 17.8647 58.708 18.1122C58.8041 18.3596 58.8336 18.6332 58.7929 18.8992C58.7523 19.1653 58.6432 19.4122 58.4792 19.6097L55.716 22.9394C55.3717 23.3449 55.1468 23.8595 55.0721 24.4132C54.9973 24.967 55.0763 25.5331 55.2982 26.0348L56.1845 28.0905C56.2829 28.3275 56.4404 28.5276 56.6378 28.6666C56.8353 28.8056 57.0644 28.8776 57.2975 28.874H64.9864C65.1988 28.8737 65.4076 28.8121 65.5926 28.695C65.7776 28.5778 65.9325 28.4092 66.0425 28.2053C66.1524 28.0014 66.2136 27.7692 66.2201 27.531C66.2267 27.2929 66.1784 27.0568 66.0799 26.8457L54.5801 2.17939C54.3761 1.72643 54.0627 1.34681 53.6758 1.08371C53.2889 0.820614 52.8439 0.684608 52.3915 0.691168H42.5205C42.0583 0.684126 41.6039 0.82571 41.2111 1.09917C40.8183 1.37264 40.5036 1.76654 40.3041 2.2343L29.4376 26.8732C29.3444 27.0843 29.3007 27.3185 29.3106 27.5538C29.3205 27.7891 29.3838 28.0177 29.4944 28.2179C29.605 28.4182 29.7592 28.5835 29.9426 28.6983C30.126 28.8131 30.3325 28.8735 30.5425 28.874H37.4985C37.7327 28.8778 37.9629 28.805 38.1608 28.6646C38.3588 28.5242 38.516 28.3221 38.6133 28.0832L39.4832 26.0293C39.7014 25.5291 39.7779 24.9659 39.7023 24.4155C39.6267 23.8651 39.4027 23.3538 39.0604 22.9504L36.2859 19.6115C36.1218 19.414 36.0128 19.1671 35.9721 18.9011C35.9315 18.635 35.961 18.3615 36.057 18.114C36.153 17.8665 36.3114 17.6559 36.5127 17.5079C36.714 17.36 36.9494 17.2812 37.1901 17.2812H41.5592C42.0316 17.2877 42.4953 17.1392 42.8934 16.854C43.2916 16.5688 43.6067 16.1593 43.8001 15.6759L46.1062 10.0982C46.2044 9.8606 46.3607 9.65904 46.5568 9.51692C46.753 9.3748 46.981 9.29794 47.2146 9.29526C47.4481 9.29258 47.6775 9.36418 47.8762 9.50176C48.0749 9.63935 48.2348 9.83728 48.3373 10.0726H48.3471Z",
    fill: "url(#paint6_linear_3548_73169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3548_73169",
    x1: 15.4512,
    y1: 0.644531,
    x2: 15.4512,
    y2: 28.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3548_73169",
    x1: 82.839,
    y1: 0.125488,
    x2: 82.839,
    y2: 28.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3548_73169",
    x1: 119.962,
    y1: 0.644531,
    x2: 119.962,
    y2: 28.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3548_73169",
    x1: 153.966,
    y1: 0.652832,
    x2: 153.966,
    y2: 28.3505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3548_73169",
    x1: 190.18,
    y1: 0.12207,
    x2: 190.18,
    y2: 28.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3548_73169",
    x1: 225.041,
    y1: 0.644531,
    x2: 225.041,
    y2: 28.3514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3548_73169",
    x1: 47.765,
    y1: 0.690918,
    x2: 47.765,
    y2: 28.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FFF701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC662C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/Jackpot.e39c7dbaf90b705ca0c14dc7f5dc5d78.svg";
export { ForwardRef as ReactComponent };